/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Student_PriceInputs */

const en_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 14.99`)
};

const de_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 14,99`)
};

const fr_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 14,99`)
};

const es_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 14,99`)
};

const it_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 14,99`)
};

const nl_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 14,99`)
};

const pl_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14,99 EUR`)
};

const fi_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14,99 EUR`)
};

const da_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 14,99`)
};

const sv_settings_student_price = /** @type {(inputs: Settings_Student_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 14,99`)
};

/**
* | output |
* | --- |
* | "EUR 14.99" |
*
* @param {Settings_Student_PriceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_student_price = /** @type {((inputs?: Settings_Student_PriceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Student_PriceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_student_price(inputs)
	if (locale === "fr") return fr_settings_student_price(inputs)
	if (locale === "es") return es_settings_student_price(inputs)
	if (locale === "it") return it_settings_student_price(inputs)
	if (locale === "nl") return nl_settings_student_price(inputs)
	if (locale === "pl") return pl_settings_student_price(inputs)
	if (locale === "fi") return fi_settings_student_price(inputs)
	if (locale === "da") return da_settings_student_price(inputs)
	if (locale === "sv") return sv_settings_student_price(inputs)
	return en_settings_student_price(inputs)
});